import Organization from "./Organization";
import {ResourceOwnerType} from "./ResourceOwnerType";

export interface AiPromptUsage {
    kind: "AI_EXTRACTOR" | "AI_REPORT_SUMMARIZER";
    id: string;
    name: string;
    systemPrompt: boolean;
    supplementaryPrompt: boolean;
}

class AiPrompt {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public name?: string,
        public prompt?: string,
        public owner?: ResourceOwnerType,
        public organization?: Organization,
        public configKeys?: string[],
        public manageable?: boolean,
        public description?: string,
        public inUse?: boolean,
        public usage?: AiPromptUsage[],
        public usageTruncated?: boolean
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entity = new AiPrompt();

        entity.id = data.id;
        entity.createdAt = data.createdAt ? new Date(data.createdAt) : undefined;
        entity.name = data.name;
        entity.description = data.description;
        entity.prompt = data.prompt;
        entity.owner = data.owner;
        entity.organization = data.organization ? Organization.fromPOJO(data.organization) : undefined;
        entity.configKeys = data.configKeys || [];
        entity.manageable = data.manageable;
        entity.inUse = data.inUse;
        entity.usage = data.usage;
        entity.usageTruncated = data.usageTruncated;

        return entity;
    }
}

export default AiPrompt;
